import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import * as React from 'react';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter } from 'react-router-dom';
import ActiveTabContextProvider from './logic/activeTabContext/ActiveTabContextProvider';
import { AuthenticatedApolloClient } from './logic/api/graphQL/AuthenticatedApolloProvider';
import ErrorBoundary from './logic/errorHandling/ErrorBoundary';
import LoadingContextProvider from './logic/loadingContext/LoadingContextProvider';
import { useIsLocalDev } from './logic/otherUtilities/useIsLocalDev';
import { OidcAuthProvider } from './logic/security/authentication/OidcAuthProvider';
import SleekConSleekContextProvider from './logic/sleekContext/SleekContextProvider';
import { useCreateTheme } from './logic/theming/createTheme';
import RootRouter from './pages/RootRouter';

const Startup: React.FC = () => {
  // Root's only responsibility is catching errors
  // There can be no logic in this component - that would risk creating uncaught errors

  return (
    <React.Fragment>
      <ErrorBoundary>
        <ErrorBoundedStartup />
      </ErrorBoundary>
    </React.Fragment>
  );
};

function ErrorBoundedStartup() {
  const theme = useCreateTheme();
  const redirectUri = window.location.origin + '/callback';
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider hideIconVariant maxSnack={5} preventDuplicate>
        <SleekConSleekContextProvider>
          <ErrorBoundary>
            <OidcAuthProvider
              redirectUri={redirectUri}
              clientId={'173830320004-t7r40i9jihr5atp1mj1skp8i493v3ip0.apps.googleusercontent.com'}
              setUserInLogging={() => {}}
              authority={'https://accounts.google.com/'}
            >
              <BrowserRouter>
                <ActiveTabContextProvider>
                  <AuthenticatedApolloClient>
                    <LoadingContextProvider>
                      <RootRouter />
                    </LoadingContextProvider>
                  </AuthenticatedApolloClient>
                </ActiveTabContextProvider>
              </BrowserRouter>
            </OidcAuthProvider>
          </ErrorBoundary>
        </SleekConSleekContextProvider>
      </SnackbarProvider>
    </MuiThemeProvider>
  );
}

export default hot(Startup);
